<template>
  <aside class="sidebar">
    <!-- Cool switch za promenu teme na vrhu -->
    <button
      class="close-icon"
      @click="$emit('close-sidebar')"
      aria-label="Close Sidebar"
    >
      <i class="pi pi-times"></i>
    </button>

    <div class="theme-switch-container">
      <label class="theme-switch">
        <input type="checkbox" v-model="isDarkMode" @change="toggleTheme" />
        <span class="slider">
          <i class="pi pi-sun sun-icon"></i>
          <i class="pi pi-moon moon-icon"></i>
        </span>
      </label>
    </div>
    <div class="d-flex justify-center">
      <LanguageSwitcher />
    </div>

    <!-- Meni sa stavkama -->
    <Menu :model="model">
      <template #item="{ item, props }">
        <router-link
          :to="item.route"
          class="p-menu-item-link"
          @click="handleLinkClick"
        >
          <span :class="item.icon"></span>
          <span class="ml-2">{{ item.label }}</span>
        </router-link>
      </template>
    </Menu>

    <!-- Logout opcija na dnu -->
    <div
      class="logout-container p-menu-submenu-label w-full"
      @click="handleLogout"
    >
      <span class="pi pi-sign-out"></span>
      <span class="ml-2">{{ $t("navigation.logout") }}</span>
    </div>
  </aside>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import LanguageSwitcher from "@/components/app/LanguageSwitcher/LanguageSwitcher.vue";

export default defineComponent({
  name: "SidebarMenu",
  props: {
    model: {
      type: Array,
      required: true,
    },
  },
  components: { LanguageSwitcher },
  emits: ["close-sidebar"],
  setup(props, { emit }) {
    const globalStore = useGlobalStore();
    const isDarkMode = ref(globalStore.isDarkMode);

    const toggleTheme = () => {
      globalStore.toggleTheme();
      isDarkMode.value = globalStore.isDarkMode;
    };

    return {
      handleLinkClick: () => {
        if (window.innerWidth <= 840) emit("close-sidebar");
      },
      handleLogout: globalStore.logOutUser,
      isDarkMode,
      toggleTheme,
      globalStore,
    };
  },
});
</script>

<style scoped>
/* Cool switch inspired by Codepen */
.theme-switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.theme-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.theme-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4d4d4d;
}

input:checked + .slider:before {
  transform: translateX(30px);
}

/* Sun and moon icons inside the switch */
.sun-icon {
  position: absolute;
  top: 50%;
  left: 6px;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #f39c12;
}

.moon-icon {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #f1c40f;
}

input:checked + .slider .sun-icon {
  opacity: 0;
  transition: opacity 0.3s ease;
}

input:not(:checked) + .slider .moon-icon {
  opacity: 0;
  transition: opacity 0.3s ease;
}

input:checked + .slider .moon-icon {
  opacity: 1;
}

input:not(:checked) + .slider .sun-icon {
  opacity: 1;
}
.logout-container:hover {
  cursor: pointer;
  background-color: rgba(255, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}
.logout-container {
  position: absolute;
  bottom: 2px;
}
</style>
